import { render } from "./DeleteRawMaterialConfirmationModal.vue?vue&type=template&id=e083f3d0&ts=true"
import script from "./DeleteRawMaterialConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteRawMaterialConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__